import { AlpineComponent } from "alpinejs";
import { GoogleService } from "../api";

type ProductPageComponent = AlpineComponent<object>;

export default (partNo: string): ProductPageComponent => {
	return {
		async init() {
			if (partNo) {
				const viewItem = await GoogleService.viewItem({ query: { partNo: partNo } });
				if (viewItem.data) {
					if (viewItem.data.currency == "") {
						delete viewItem.data.currency;
						delete viewItem.data.value;
						delete viewItem.data.items[0].price;
					}
				}
				window.dataLayer.push({
					ecommerce: null,
				});
				window.dataLayer.push({
					event: "view_item",
					ecommerce: viewItem.data,
				});
			}
		},
	};
};
